import { GET, POST, PUT, DELETE } from "../../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchTemplates = () =>
  GET("admin/notifications/template").pipe(map((response: any) => response));

export const fetchDeleteTemplate = (templateId: number) =>
  DELETE(`admin/notifications/template/${templateId}`).pipe(
    map((response: any) => response)
  );

export const fetchUpdateTemplate = (body: any[]) =>
  PUT("admin/notifications/template", body).pipe(
    map((response: any) => response)
  );

export const fetchCreateTemplate = (body: any[]) =>
  POST("admin/notifications/template", body).pipe(
    map((response: any) => response)
  );
